import React from 'react';
import ReactDOM from 'react-dom';
import OKRExcelExportModal from './okr-export-excel';

const okrExportPopup = (attrs) => {
    if (document.getElementById('export-key-results-widget')) {
        ReactDOM.unmountComponentAtNode(document.getElementById('export-key-results-widget'));
    }
    ReactDOM.render(<OKRExcelExportModal {...attrs} />, document.getElementById('export-key-results-widget'));
}

window.okrExportPopup = okrExportPopup;